<template>
  <div>
    <FilePond
      name="archive[file]"
      :server="pondServerConfig"
      v-bind:files="pondFiles"
      :label-idle="label"
      allow-multiple="true"
      :filePosterMaxHeight="previewHeigth"
      :filePosterMinHeight="previewHeigth"
      :filePosterHeight="previewHeigth"
      :imagePreviewHeight="previewHeigth"
      :imagePreviewMinHeight="previewHeigth"
      :imagePreviewMaxHeight="previewHeigth"
      v-bind:onactivatefile="clickFile"
      v-bind:onprocessfilestart="onprocessfilestart"
      v-bind:onprocessfiles="onprocessfiles"
      :allowDrop="!disabled"
      :allowBrowse="!disabled"
      :allowPaste="!disabled"
      :allowRevert="!disabled"
      :allowRemove="!disabled"
      :allowProcess="!disabled"
      image-transform-output-mime-type="image/jpeg"
    />

    <v-overlay :value="overlay" opacity="1" z-index="100">
      <v-container v-if="currentFile" class="file-view-overflow">
        <v-row dense align="center" justify="space-between">
          <v-col class="font-weight-bold text-center">
            <v-row dense>
              <v-col>
                {{ currentFile.file_name }}
              </v-col>
            </v-row>

            <v-row dense>
              <v-col> ({{ currentFileIndex + 1 }}/{{ pondFiles.length }}) </v-col>
            </v-row>
          </v-col>

          <v-col cols="auto">
            <v-btn dark @click="downloadFile">
              Download
            </v-btn>

            <v-btn icon @click="overlay = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <v-row dense align="center" justify="space-between" class="fill-height">
          <v-col cols="auto">
            <v-btn icon @click="previousFile">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="10">
            <v-img
              :src="this.currentFile.metadata.poster"
              :alt="currentFile.fileName"
              contain
            />
          </v-col>

          <v-col cols="auto">
            <v-btn icon @click="nextFile">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-overlay>
  </div>
</template>

<script>
  import GET_ARCHIVES from "@/graphql/archives.gql";
  import DELETE_ARCHIVES from "@/graphql/delete_archive.gql";

  import vueFilePond from "vue-filepond";
  import "filepond/dist/filepond.min.css";

  import FilePondPluginImagePreview from "filepond-plugin-image-preview";
  import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";

  import FilePondPluginFilePoster from "filepond-plugin-file-poster";
  import "filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css";

  import FilePondPluginImageTransform from "filepond-plugin-image-transform";

  const FilePond = vueFilePond(
    FilePondPluginImagePreview,
    FilePondPluginFilePoster,
    FilePondPluginImageTransform
  );

  import defaultImage from "@/assets/mini-logo.svg";

  export default {
    name: "FileUpload",
    components: {
      FilePond,
    },
    props: {
      ownerType: String,
      ownerId: String,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        archives: [],
        previewHeigth: 150,
        overlay: false,
        currentFile: null,
        defaultImage: defaultImage,
        pondServerConfig: {
          url: process.env.VUE_APP_BASE_URL,
          process: {
            url: `/archives`,
            method: "POST",
            headers: { Authorization: this.$store.state.authentication.token },
            onload: (response) => {
              return response;
            },
            onerror: (response) => {
              return response.data;
            },
            ondata: (formData) => {
              formData.append("archive[owner_type]", this.ownerType);
              formData.append("archive[owner_id]", this.ownerId);
              return formData;
            },
          },
          revert: (source, load, error) => {
            this.deleteArchive(source, load, error);
          },
          remove: (source, load, error) => {
            this.deleteArchive(source, load, error);
          },
        },
      };
    },
    mounted() {
      this.refreshList();
    },
    apollo: {
      archives: {
        query: GET_ARCHIVES,
        variables() {
          return {
            ownerType: this.ownerType,
            ownerId: this.ownerId,
          };
        },
      },
    },
    computed: {
      label() {
        if (this.disabled) return "Arquivos somente leitura";

        return "Arraste & solte o seu arquivo aqui ou <u>Procure</u>";
      },
      pondFiles() {
        return this.archives.map(function(archive) {
          let poster = defaultImage;

          if (archive.fileExtension.includes("image")) {
            poster = `${process.env.VUE_APP_BASE_URL}${archive.fileUrl}`;
          }

          return {
            source: archive.id,
            file_url: archive.fileUrl,
            file_name: archive.fileName,
            options: {
              type: "local",
              file: {
                name: archive.fileName,
                size: archive.fileSize,
                type: archive.fileExtension,
              },
              metadata: {
                poster: poster,
                fileUrl: `${process.env.VUE_APP_BASE_URL}${archive.fileUrl}`,
              },
            },
            metadata: {
              poster: poster,
            },
          };
        });
      },
      currentFileIndex() {
        return this.lodash.findIndex(this.pondFiles, {
          source: this.currentFile.source,
        });
      },
    },
    methods: {
      refreshList(){
        this.$apollo.queries.archives.refetch();
      },
      deleteArchive(source, load, error) {
        if (this.disabled) {
          this.$store.dispatch("createNotification", {
            message: "Arquivos somente leitura.",
            type: "warning",
          });
          return error("Não deletado");
        }

        if (confirm("Você realmente deseja deletar esse arquivo?")) {
          this.apolloMutate({
            mutation: DELETE_ARCHIVES,
            variables: {
              archiveId: source,
            },
          }).then(() => {
            this.refreshList();
          });
        } else {
          error("Não deletado");
        }
      },
      clickFile(file) {
        const archive = this.lodash.find(this.pondFiles, {
          source: file.source,
        });

        this.currentFile = archive;

        if (this.currentFile) {
          this.overlay = true;
        }
      },
      downloadFile() {
//        this.$store.dispatch("authentication/refreshToken");

        window.open(this.currentFile.options.metadata.fileUrl, "_blank");
      },
      nextFile() {
        let nextIndex = this.currentFileIndex + 1;

        let nextFile = this.lodash.first(this.pondFiles);
        if (nextIndex < this.pondFiles.length) nextFile = this.pondFiles[nextIndex];

        this.clickFile(nextFile);
      },
      previousFile() {
        let previousIndex = this.currentFileIndex - 1;

        let previousFile = this.lodash.last(this.pondFiles);
        if (previousIndex >= 0) previousFile = this.pondFiles[previousIndex];

        this.clickFile(previousFile);
      },
      onprocessfilestart() {
        this.$apollo.queries.archives.stop();
      },
      onprocessfiles() {
        this.$apollo.queries.archives.start();
        this.$apollo.queries.archives.refetch();
      },
    },
  };
</script>

<style lang="scss">
  .filepond--item {
    width: calc(33.33% - 0.5em);
    &:hover {
      cursor: pointer;
    }
  }

  .file-view-overflow {
    width: 100vw;
    height: 100vh;
  }
</style>
